import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Service = () => {
    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
            offset: 100,
            easing: 'ease-out-cubic',
            startEvent: 'DOMContentLoaded',
        });
        
        // Refresh AOS when window loads
        window.addEventListener('load', AOS.refresh);
        
        return () => {
            window.removeEventListener('load', AOS.refresh);
        };
    }, []);

    return (
        <>
            <div
                className="container-fluid page-header py-5"
                style={{ marginBottom: "6rem" }}
                data-aos="fade-down"
            >
                <div className="container py-5">
                    <h1 className="display-3 text-white mb-3">What We Do</h1>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container py-5">
                    <div
                        className="text-center"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        <h6 className="text-secondary text-uppercase">Our Services</h6>
                        <h1 className="mb-5">Explore Our Services</h1>
                    </div>

                    <div className="row g-4 justify-content-center">
                        {/* Academic Education - New Service */}
                        <div
                            className="col-md-6 col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            <div className="service-item p-4 h-100">
                                <div className="overflow-hidden mb-4" style={{ height: "200px" }}>
                                    <img
                                        className="img-fluid w-100 h-100"
                                        src="img/service-08.jpg"
                                        alt="Academic Education Services"
                                        style={{ objectFit: "cover" }}
                                        data-aos="zoom-in"
                                        data-aos-delay="300"
                                    />
                                </div>
                                <h4 className="mb-3">Academic Education</h4>
                                <p>Comprehensive educational support including curriculum development, tutoring, and e-learning solutions for academic institutions.</p>
                                <a
                                    className="btn-slide mt-2"
                                    href="/academic"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    <i className="fa fa-arrow-right"></i><span>Read More</span>
                                </a>
                            </div>
                        </div>

                        {/* Medical Billing */}
                        <div
                            className="col-md-6 col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            <div className="service-item p-4 h-100">
                                <div className="overflow-hidden mb-4" style={{ height: "200px" }}>
                                    <img
                                        className="img-fluid w-100 h-100"
                                        src="img/service-01.jpg"
                                        alt="Medical Billing Services"
                                        style={{ objectFit: "cover" }}
                                        data-aos="zoom-in"
                                        data-aos-delay="300"
                                    />
                                </div>
                                <h4 className="mb-3">Medical Billing</h4>
                                <p>Streamlined healthcare billing, claims processing, and accurate reimbursement support for hospitals and clinics.</p>
                                <a
                                    className="btn-slide mt-2"
                                    href="/med"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    <i className="fa fa-arrow-right"></i><span>Read More</span>
                                </a>
                            </div>
                        </div>

                        {/* Annotation & Data Entry Services */}
                        <div
                            className="col-md-6 col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            <div className="service-item p-4 h-100">
                                <div className="overflow-hidden mb-4" style={{ height: "200px" }}>
                                    <img
                                        className="img-fluid w-100 h-100"
                                        src="img/service-02.jpg"
                                        alt="Annotation & Data Entry Services"
                                        style={{ objectFit: "cover" }}
                                        data-aos="zoom-in"
                                        data-aos-delay="400"
                                    />
                                </div>
                                <h4 className="mb-3">Annotation & Data Entry Services</h4>
                                <p>High-quality data labeling and precise data entry to support AI models, documentation, and digital operations.</p>
                                <a
                                    className="btn-slide mt-2"
                                    href="/data"
                                    data-aos="fade-up"
                                    data-aos-delay="500"
                                >
                                    <i className="fa fa-arrow-right"></i><span>Read More</span>
                                </a>
                            </div>
                        </div>

                        {/* Web Development - New Service */}
                        <div
                            className="col-md-6 col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="400"
                        >
                            <div className="service-item p-4 h-100">
                                <div className="overflow-hidden mb-4" style={{ height: "200px" }}>
                                    <img
                                        className="img-fluid w-100 h-100"
                                        src="img/service-07.webp"
                                        alt="Web Development Services"
                                        style={{ objectFit: "cover" }}
                                        data-aos="zoom-in"
                                        data-aos-delay="500"
                                    />
                                </div>
                                <h4 className="mb-3">Web Development</h4>
                                <p>Custom web solutions, from responsive websites to complex web applications, tailored to your business needs.</p>
                                <a
                                    className="btn-slide mt-2"
                                    href="/webdev"
                                    data-aos="fade-up"
                                    data-aos-delay="600"
                                >
                                    <i className="fa fa-arrow-right"></i><span>Read More</span>
                                </a>
                            </div>
                        </div>

                        {/* Training Services */}
                        <div
                            className="col-md-6 col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="500"
                        >
                            <div className="service-item p-4 h-100">
                                <div className="overflow-hidden mb-4" style={{ height: "200px" }}>
                                    <img
                                        className="img-fluid w-100 h-100"
                                        src="img/service-09.jpeg"
                                        alt="Training Services"
                                        style={{ objectFit: "cover" }}
                                        data-aos="zoom-in"
                                        data-aos-delay="600"
                                    />
                                </div>
                                <h4 className="mb-3">Training Services</h4>
                                <p>Professional skill-development programs designed to equip teams with industry-ready knowledge and tools.</p>
                                <a
                                    className="btn-slide mt-2"
                                    href="/training"
                                    data-aos="fade-up"
                                    data-aos-delay="700"
                                >
                                    <i className="fa fa-arrow-right"></i><span>Read More</span>
                                </a>
                            </div>
                        </div>

                        {/* Man Power Services */}
                        <div
                            className="col-md-6 col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="600"
                        >
                            <div className="service-item p-4 h-100">
                                <div className="overflow-hidden mb-4" style={{ height: "200px" }}>
                                    <img
                                        className="img-fluid w-100 h-100"
                                        src="img/service-04.jpg"
                                        alt="Man Power Services"
                                        style={{ objectFit: "cover" }}
                                        data-aos="zoom-in"
                                        data-aos-delay="700"
                                    />
                                </div>
                                <h4 className="mb-3">Man Power Services</h4>
                                <p>Reliable staffing solutions providing skilled and unskilled workforce for various business needs.</p>
                                <a
                                    className="btn-slide mt-2"
                                    href="/man"
                                    data-aos="fade-up"
                                    data-aos-delay="800"
                                >
                                    <i className="fa fa-arrow-right"></i><span>Read More</span>
                                </a>
                            </div>
                        </div>

                        {/* Computer Hardware Equipment Services - Fixed to center properly */}
                        <div
                            className="col-md-6 col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="700"
                        >
                            <div className="service-item p-4 h-100">
                                <div className="overflow-hidden mb-4" style={{ height: "200px" }}>
                                    <img
                                        className="img-fluid w-100 h-100"
                                        src="img/service-05.jpeg"
                                        alt="Computer Hardware Equipment Services"
                                        style={{ objectFit: "cover" }}
                                        data-aos="zoom-in"
                                        data-aos-delay="800"
                                    />
                                </div>
                                <h4 className="mb-3">Computer Hardware Equipment Services</h4>
                                <p>Expert hardware installation, maintenance, and IT support to keep your systems running smoothly.</p>
                                <a
                                    className="btn-slide mt-2"
                                    href="/hardware"
                                    data-aos="fade-up"
                                    data-aos-delay="900"
                                >
                                    <i className="fa fa-arrow-right"></i><span>Read More</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add custom styles for animations */}
            <style jsx>{`
                .service-item {
                    background: #fff;
                    border-radius: 10px;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.05);
                    transition: all 0.3s ease;
                    border: 1px solid #f0f0f0;
                }
                
                .service-item:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 15px 30px rgba(0,0,0,0.1);
                    border-color: #0d6efd;
                }
                
                .service-item img {
                    transition: transform 0.5s ease;
                }
                
                .service-item:hover img {
                    transform: scale(1.05);
                }
                
                .btn-slide {
                    display: inline-flex;
                    align-items: center;
                    color: #0d6efd;
                    text-decoration: none;
                    font-weight: 500;
                    transition: all 0.3s ease;
                }
                
                .btn-slide i {
                    transition: transform 0.3s ease;
                }
                
                .btn-slide:hover {
                    color: #0a58ca;
                }
                
                .btn-slide:hover i {
                    transform: translateX(5px);
                }
                
                .btn-slide span {
                    margin-left: 8px;
                }
                
                .page-header {
                    background: linear-gradient(rgba(6, 3, 21, 0.8), rgba(6, 3, 21, 0.8)), 
                                url('img/carousel-01.jpg') no-repeat center center;
                    background-size: cover;
                }
                
                /* Mobile responsiveness */
                @media (max-width: 768px) {
                    .service-item {
                        margin-bottom: 1.5rem;
                    }
                    
                    .display-3 {
                        font-size: 2.5rem;
                    }
                }
                
                @media (max-width: 576px) {
                    .display-3 {
                        font-size: 2rem;
                    }
                    
                    .service-item {
                        padding: 1.5rem !important;
                    }
                }
            `}</style>
        </>
    );
}

export default Service;